import type { ServiceAccountingOperation } from '../model/types';

/** Stable React key — index suffix avoids duplicates from legacy API groups. */
export const getOperationKey = (operation: ServiceAccountingOperation, index: number): string =>
  `${operation.id || 'operation'}-${index}`;
